import { createFeatureSelector } from '@ngrx/store';

export const venueImagesState = createFeatureSelector<OLO.State, OLO.State.VenuesImages>('venuesImages');
